import { Role } from '../classes/Role';

export interface ExtendedRole {
  displayName: string;
  value: Role;
}

export class RoleHelper {
  static Roles: ExtendedRole[] = [
    {
      // The role is still called Administrator in the identity server and the API; users know it as Podcaster.
      displayName: 'Podcaster',
      value: Role.Administrator,
    },
    {
      displayName: 'Company Administrator',
      value: Role.CompanyAdministrator,
    },
    {
      displayName: 'Listener',
      value: Role.User,
    },
  ];

  static GetExtendedRoleByNameOrNull(displayName: string): ExtendedRole | null {
    const result = RoleHelper.Roles.find((status: ExtendedRole) => status.value === displayName);
    return result ?? null;
  }

  static GetExtendedRoleByValueOrNull(value: Role | string | null | undefined): ExtendedRole | null {
    const result = RoleHelper.Roles.find((status: ExtendedRole) => status.value === value);
    return result ?? null;
  }
}
